import { SocialSharing, SocialSharingGroup } from '@change/ds-core-ui';
import { EmailIcon, FacebookIcon, TwitterIcon, WhatsAppIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useShareClickHandlers } from './hooks/useShareClickHandlers';

export const ShareGroup: React.FC = () => {
	const { onFacebookClick, onTwitterClick, onEmailClick, onWhatsAppClick } = useShareClickHandlers();
	const { translate } = useI18n();

	return (
		<SocialSharingGroup layout="grid" className="mt-10 w-full grid-cols-2 items-start sm:grid-cols-4">
			<SocialSharing
				icon={<FacebookIcon />}
				label={translate('fe.components.psf.share.buttons.short.facebook')}
				size="large"
				variant="facebook"
				className="mt-6 justify-self-center"
				aria-label={translate('fe.components.psf.share.buttons.short.facebook')}
				data-testid="movement-share-facebook"
				data-qa="movement-share-facebook"
				onClick={onFacebookClick}
			/>
			<SocialSharing
				icon={<TwitterIcon />}
				label={translate('fe.components.psf.share.buttons.short.twitter')}
				size="large"
				variant="twitter"
				className="mt-6 justify-self-center"
				aria-label={translate('fe.components.psf.share.buttons.short.twitter')}
				data-testid="movement-share-twitter"
				data-qa="movement-share-twitter"
				onClick={onTwitterClick}
			/>
			<SocialSharing
				icon={<EmailIcon />}
				label={translate('fe.components.psf.share.buttons.short.email')}
				size="large"
				variant="default"
				className="mt-6 justify-self-center"
				aria-label={translate('fe.components.psf.share.buttons.short.email')}
				data-testid="movement-share-email"
				data-qa="movement-share-email"
				onClick={onEmailClick}
			/>
			<SocialSharing
				icon={<WhatsAppIcon />}
				label={translate('fe.components.psf.share.buttons.short.whatsapp')}
				size="large"
				variant="whatsapp"
				className="mt-6 justify-self-center"
				aria-label={translate('fe.components.psf.share.buttons.short.whatsapp')}
				data-testid="movement-share-whatsapp"
				data-qa="movement-share-whatsapp"
				onClick={onWhatsAppClick}
			/>
		</SocialSharingGroup>
	);
};
